// extracted by mini-css-extract-plugin
module.exports = {"Toc__root":"EceP","Toc__content":"CjPJ","Toc__title":"R8e1","Toc__content_inner":"A5pn","Toc__icon":"_4xhw"};